<template>
  <label>
      <ms-icon class="icon"
      v-if="icon"
      :icon="icon"
      :size="sizeIcon"
    ></ms-icon>
      <slot></slot>
      <span v-if="required" class="required">
          *
      </span>
  </label>
</template>
<script>
export default {
  name: "MsLabel",
  props:{
    required: {
          default: false,
          type: [String, Boolean]

      },
    icon:{
      type:String,
      default:null
    },
    sizeIcon: {
      default: "10px",
      type: String
    }
  }
};
</script>
<style lang="scss" >
label{
    text-align: left;
    display: flex;
    align-items: center;
}
.required{
    color: red;
    padding-left: 2px;
}
</style>
